<app-side-top-bar [navigationItems]="navigationItems">
  <main class="documents-page">
    <div
      [ngClass]="
        isPatientActive ? 'patient-name' : 'patient-name name-not-active'
      "
    >
      <h2>{{ patientNameAndSurname }}</h2>
    </div>
    <section class="document-section">
      <header class="header">
        <h2>{{ labelService.getLabel("Documenti Paziente") }}</h2>
        <div class="header-buttons">
          <app-button
            [icon]="'add'"
            (click)="toggleAddDocumentPanel()"
          ></app-button>
        </div>
      </header>

      @if (documents.length > 0 && !isLoading) {
        <div class="table-container">
          <table mat-table [dataSource]="documents" class="document-table">
            <!-- Date Column -->
            <ng-container matColumnDef="date">
              <th mat-header-cell *matHeaderCellDef style="width: 15%">Data</th>
              <td mat-cell *matCellDef="let document">{{ document.date }}</td>
            </ng-container>
            <!-- Title Column -->
            <ng-container matColumnDef="title">
              <th mat-header-cell *matHeaderCellDef>Titolo</th>
              <td mat-cell *matCellDef="let document">{{ document.title }}</td>
            </ng-container>
            <!-- Formato Column -->
            <ng-container matColumnDef="format">
              <th mat-header-cell *matHeaderCellDef style="width: 15%">
                Formato
              </th>
              <td mat-cell *matCellDef="let module">
                {{ displayFileType(module.file_content_type) }}
              </td>
            </ng-container>
            <!-- Actions Column -->
            <ng-container matColumnDef="actions">
              <th mat-header-cell *matHeaderCellDef style="width: 100px"></th>
              <td mat-cell *matCellDef="let document">
                <button
                  mat-icon-button
                  [matMenuTriggerFor]="menu"
                  class="action-button"
                >
                  <mat-icon>more_vert</mat-icon>
                </button>
                <mat-menu #menu="matMenu">
                  @if (document.file_content_type === "application/pdf") {
                    <button
                      mat-menu-item
                      (click)="handleMenuAction('preview', document)"
                    >
                      <mat-icon>visibility</mat-icon>
                      <span>Anteprima</span>
                    </button>
                  }
                  <button
                    mat-menu-item
                    (click)="handleMenuAction('download', document)"
                  >
                    <mat-icon>download</mat-icon>
                    <span>Download</span>
                  </button>
                  <button
                    mat-menu-item
                    (click)="handleMenuAction('edit', document)"
                  >
                    <mat-icon>edit</mat-icon>
                    <span>Modifica</span>
                  </button>
                  <button
                    mat-menu-item
                    (click)="handleMenuAction('delete', document)"
                  >
                    <mat-icon>delete</mat-icon>
                    <span>Elimina</span>
                  </button>
                </mat-menu>
              </td>
            </ng-container>
            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
          </table>
        </div>
      }

      @if (isLoading) {
        <div class="loading-container">
          <app-loader [size]="'big'"></app-loader>
        </div>
      }

      @if (documents.length === 0 && !isLoading) {
        <div class="no-documents">
          <img
            src="assets/imgs/undraw/undraw_empty.svg"
            alt="Nessun Documento"
          />
          <span>Nessun documento caricato</span>
        </div>
      }
    </section>

    @if (showAddDocumentPanel) {
      <app-panel-with-document-upload
        [title]="'Nuovo Documento'"
        [inputBoxes]="inputBoxesForNewDocument"
        (cancel)="toggleAddDocumentPanel()"
        (confirm)="confirmNewDocument($event)"
      ></app-panel-with-document-upload>
    }

    <!-- modify module panel -->
    @if (showModifyDocumentPanel) {
      <app-panel-with-input-boxes
        [title]="'Modifica Documento'"
        [inputBoxes]="inputBoxesForModifyDocument"
        (cancel)="toggleModifyPanel()"
        (confirm)="modifyDocument($event)"
      ></app-panel-with-input-boxes>
    }
  </main>
</app-side-top-bar>
